
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1403',
  depVersions: {
  "customer-portal-app": "static-1.1403",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.437",
  "data-fetching-client": "static-1.9338",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.371",
  "growth-payments-core": "static-1.24334",
  "head-dlb": "static-1.4702",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5253",
  "hs-test-utils": "static-1.7646",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9129",
  "hubspot-dlb": "static-2.1773",
  "hubspot-prosemirror": "static-1.17236",
  "hubspot-url-utils": "static-1.3825",
  "HubStyleTokens": "static-2.11082",
  "I18n": "static-7.1532",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6116",
  "payment-link-components": "static-1.22560",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6525",
  "quartz-core": "static-1.5744",
  "react": "static-7.174",
  "react-colorpicker": "static-2.9877",
  "react-dlb": "static-1.68",
  "react-utils": "static-2.5051",
  "rich-text-lib": "static-1.19234",
  "transmute": "static-2.77",
  "ui-addon-upgrades": "static-9.17363",
  "ui-components-test-utils": "static-1.5220",
  "UIComponents": "static-3.8029",
  "foundations-assets": "static-1.4492",
  "foundations-components": "static-1.7218",
  "foundations-theming": "static-1.4064",
  "foundations-theming-specialty": "static-1.1780",
  "framer-motion": "static-1.62",
  "history": "static-4.47",
  "metrics-js": "static-1.9296",
  "PortalIdParser": "static-2.334",
  "portals-platform-lib": "static-1.380",
  "quartz-config": "static-1.303",
  "quick-fetch": "static-1.3600",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16288",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7804",
  "styled-components": "static-2.83",
  "tanstack-table": "static-1.48",
  "ui-addon-draggable": "static-3.4408",
  "ui-addon-react-router-dom": "static-1.9204",
  "usage-tracker": "static-1.6999",
  "usage-tracker-anonymous": "static-1.5416",
  "usage-tracker-core": "static-1.6849",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven": "static-3.5564",
  "raven-hubspot": "static-1.5871",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.65",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3099",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2802",
  "quartz-webpack": "static-1.2749",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.75",
  "commerce-analytics-service-client": "static-1.3346",
  "customer-data-objects": "static-1.7273",
  "frontend-preferences-client": "static-1.7587",
  "laboratory-lib": "static-3.6803",
  "onboarding-scopes": "static-1.6105",
  "rpc-client-utils": "static-1.4266",
  "ui-addon-opt": "static-4.8053",
  "HeadJS": "static-2.682",
  "hs-test-utils-bend-plugin": "static-1.2757",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "ts-schema": "static-1.3777",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7250",
  "cssUtils": "static-1.687",
  "customer-data-ui-utilities": "static-1.9487",
  "HubStyle": "static-2.11390",
  "knowledge-content-types": "static-1.8263",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.200",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.481",
  "ui-addon-emoji-picker": "static-1.9555",
  "ui-addon-i18n": "static-1.10789",
  "ui-business-units-lib": "static-1.8671",
  "ui-shepherd-react": "static-3.9802",
  "video-components-external": "static-1.10144",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.3997",
  "commerce-tours-lib": "static-1.5507",
  "customer-data-properties": "static-1.50368",
  "getting-started-shared-tasks": "static-1.17465",
  "growth-onboarding-reliability": "static-1.4752",
  "onboarding-tours": "static-1.16075",
  "reference-resolvers-lite": "static-1.7755",
  "sales-checkout-service-client": "static-1.3358",
  "ui-addon-iframeable": "static-1.8667",
  "user-context": "static-1.4751",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.762",
  "hubspotter-http": "static-1.4350",
  "icons": "static-2.605",
  "mobile-manifest-mixins": "static-1.455",
  "quartz-auth": "static-1.200",
  "quartz-head": "static-1.190",
  "quartz-test": "static-1.200",
  "ui-fonts": "static-1.344",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9093",
  "data-token-picker": "static-1.15824",
  "FileManagerLib": "static-1.38131",
  "property-translator": "static-1.5078",
  "atom": "static-1.4737",
  "feature-store-service-types": "static-1.4191",
  "growth-monetization-service-types": "static-1.4198",
  "merchandise-lib": "static-1.253",
  "purchase-motions-components": "static-1.5275",
  "salesImages": "static-1.518",
  "self-service-api": "static-1.9886",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4182",
  "foundations-components-test-utils": "static-1.4701",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.91",
  "ui-images": "static-2.1047",
  "bend-plugin-foundations-components": "static-1.3487",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.58",
  "trellis-assets": "static-1.911",
  "bend-plugin-foundations-theming": "static-1.2547",
  "foundations-theming-base": "static-1.3049",
  "stylex": "static-1.25",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4139",
  "react-flip-move": "static-1.63",
  "bender-build-tools": "static-1.2770",
  "inbound-db-properties-service-client": "static-1.3552",
  "superstore": "static-1.4432",
  "feedback-loader": "static-1.28619",
  "ai-components-ui-library": "static-1.7991",
  "ui-addon-video-player": "static-1.8386",
  "ui-coaching-tips": "static-1.27560",
  "sassPrefix": "static-1.149",
  "react-dnd-compat": "static-1.4288",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2124",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7822",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4312",
  "content-media-composition-data-lib": "static-1.10866",
  "content-media-compositions": "static-2.14873",
  "idb-keyval": "static-1.37",
  "immer": "static-1.33",
  "immerable": "static-1.3818",
  "magpie-lib": "static-1.5237",
  "magpie-types": "static-1.4697",
  "media-bridge-lib": "static-1.18350",
  "video-data-lib": "static-1.33802",
  "commerce-products-lib": "static-1.8429",
  "crm-message-bus": "static-1.41969",
  "growth-data-modal": "static-1.4992",
  "hubspot-apollo-client": "static-1.4542",
  "onboarding-tours-client": "static-1.4289",
  "calling-global-api": "static-1.63185",
  "calling-internal-common": "static-1.30950",
  "calling-lifecycle-internal": "static-1.64567",
  "calling-lifecycle-messages": "static-1.56861",
  "conditional-properties-service-client": "static-1.3494",
  "crm-links": "static-1.5907",
  "customer-data-objects-ui-components": "static-1.12663",
  "customer-data-property-utils": "static-1.7728",
  "external-options-client-types": "static-1.3855",
  "file-manager-components": "static-1.22491",
  "framework-data-schema-resolvers": "static-1.6527",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.312",
  "inbound-db-meta-service-client": "static-1.3331",
  "inbounddb-objects-service-types": "static-1.3922",
  "meetings-icalendar-utils-lib": "static-1.297",
  "multi-currency-client-types": "static-1.3394",
  "object-builder-ui-client": "static-1.47506",
  "pipeline-validation-client-types": "static-1.3658",
  "property-value-citations": "static-1.983",
  "pulse": "static-1.145",
  "smart-property-lib": "static-1.5379",
  "tiered-pricing": "static-1.613",
  "ui-addon-form-validation": "static-1.10660",
  "growth-onboarding-confetti": "static-1.2716",
  "growth-onboarding-next-action-utils": "static-1.1151",
  "navigation-components": "static-1.16880",
  "onboarding-tours-utils": "static-1.141",
  "ui-shepherd-tracker": "static-1.7183",
  "ui-universal-auth": "static-1.8498",
  "batch-promise": "static-1.1191",
  "navigation-messaging": "static-1.6207",
  "getting-started-shared-tasks-store": "static-1.16583",
  "hubspotter-http-shared-msw-handlers": "static-1.9127",
  "audio-components": "static-1.5419",
  "FileManagerCore": "static-1.37990",
  "FileManagerImages": "static-1.35642",
  "video-components": "static-1.12147",
  "nav-client-types": "static-1.1995",
  "purchase-motions-api": "static-1.5278",
  "signup-constants": "static-1.18103",
  "signup-ui-url-generator": "static-2.7711",
  "trials-service-types": "static-1.3599",
  "chatspot-core": "static-1.19790",
  "ContentUtils": "static-1.67180",
  "copilot-toolkit": "static-1.10183",
  "growth-onboarding-feedback-components": "static-1.6250",
  "hls.js": "static-1.32",
  "reactive-lib": "static-1.390",
  "simple-logging-lib": "static-1.2714",
  "customer-data-tracking": "static-1.6525",
  "products-iframe-lib": "static-1.6988",
  "products-ui-components-shared-msw-handlers": "static-1.9511",
  "calling-error-reporting": "static-1.30956",
  "shared-worker-versioning": "static-1.10680",
  "calling-usage-tracker": "static-1.6202",
  "calling-orchestration-shared-library": "static-1.34373",
  "conversations-skeleton-state": "static-1.6915",
  "usage-tracker-container": "static-1.6989",
  "location-customization-utils-lib": "static-1.8118",
  "crm-pipelines-api-client-types": "static-1.3838",
  "framework-builder-read-service-client": "static-1.3720",
  "framework-data-schema-quick-fetch": "static-1.6432",
  "persist-promise": "static-1.3348",
  "directed-graph": "static-1.598",
  "event-emitter": "static-1.589",
  "breeze-intelligence-kit": "static-1.5122",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9212",
  "fsm": "static-1.3393",
  "policy-lib": "static-1.6466",
  "react-tinymce": "static-1.54242",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9275",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53368",
  "tinymce-plugins": "static-1.56482",
  "tinymce-themes": "static-1.55338",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4189",
  "video-embed": "static-1.34636",
  "content-icons-ui": "static-1.2102",
  "social-insights-client-types": "static-1.21028",
  "eligibility-engine-service-types": "static-1.2880",
  "chatspot-client-types": "static-1.10305",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4466",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.3955",
  "calling-orchestration-schema": "static-1.34598",
  "crm-record-cards-service-types": "static-1.3332",
  "highcharts": "static-8.97",
  "trellis-story-utils": "static-1.4188",
  "storybook-react": "static-1.26",
  "hub-http-contrib": "static-1.2711",
  "interframe": "static-3.4453",
  "tinymce-data": "static-1.39453",
  "ui-addon-sales-email": "static-1.4878",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11794",
  "layout-dnd-utils": "static-1.10769",
  "react-codemirror": "static-1.10266",
  "ui-brand-identity-lib": "static-1.13317",
  "NamespacedHubStyle": "static-2.8774",
  "outpost": "static-1.3880",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67255",
  "layout-data-lib": "static-1.9094",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.14600",
  "advanced-menus-lib": "static-1.11601",
  "ExportDialog": "static-6.10051",
  "ui-memberships-settings-lib": "static-1.33052",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14599",
  "ReduxMessenger": "static-2.10038",
  "simple-menus-lib": "static-1.16116"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1403",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.437",
  "data-fetching-client": "/data-fetching-client/static-1.9338",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.371",
  "growth-payments-core": "/growth-payments-core/static-1.24334",
  "head-dlb": "/head-dlb/static-1.4702",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5253",
  "hs-test-utils": "/hs-test-utils/static-1.7646",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9129",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17236",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyleTokens": "/HubStyleTokens/static-2.11082",
  "I18n": "/I18n/static-7.1532",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6116",
  "payment-link-components": "/payment-link-components/static-1.22560",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6525",
  "quartz-core": "/quartz-core/static-1.5744",
  "react": "/react/static-7.174",
  "react-colorpicker": "/react-colorpicker/static-2.9877",
  "react-dlb": "/react-dlb/static-1.68",
  "react-utils": "/react-utils/static-2.5051",
  "rich-text-lib": "/rich-text-lib/static-1.19234",
  "transmute": "/transmute/static-2.77",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17363",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5220",
  "UIComponents": "/UIComponents/static-3.8029",
  "foundations-assets": "/foundations-assets/static-1.4492",
  "foundations-components": "/foundations-components/static-1.7218",
  "foundations-theming": "/foundations-theming/static-1.4064",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1780",
  "framer-motion": "/framer-motion/static-1.62",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9296",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "portals-platform-lib": "/portals-platform-lib/static-1.380",
  "quartz-config": "/quartz-config/static-1.303",
  "quick-fetch": "/quick-fetch/static-1.3600",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16288",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7804",
  "styled-components": "/styled-components/static-2.83",
  "tanstack-table": "/tanstack-table/static-1.48",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4408",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9204",
  "usage-tracker": "/usage-tracker/static-1.6999",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5416",
  "usage-tracker-core": "/usage-tracker-core/static-1.6849",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven": "/raven/static-3.5564",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.65",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3099",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2802",
  "quartz-webpack": "/quartz-webpack/static-1.2749",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.75",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3346",
  "customer-data-objects": "/customer-data-objects/static-1.7273",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7587",
  "laboratory-lib": "/laboratory-lib/static-3.6803",
  "onboarding-scopes": "/onboarding-scopes/static-1.6105",
  "rpc-client-utils": "/rpc-client-utils/static-1.4266",
  "ui-addon-opt": "/ui-addon-opt/static-4.8053",
  "HeadJS": "/HeadJS/static-2.682",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2757",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "ts-schema": "/ts-schema/static-1.3777",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7250",
  "cssUtils": "/cssUtils/static-1.687",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9487",
  "HubStyle": "/HubStyle/static-2.11390",
  "knowledge-content-types": "/knowledge-content-types/static-1.8263",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.200",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9555",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10789",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8671",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9802",
  "video-components-external": "/video-components-external/static-1.10144",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.3997",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5507",
  "customer-data-properties": "/customer-data-properties/static-1.50368",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17465",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4752",
  "onboarding-tours": "/onboarding-tours/static-1.16075",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7755",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3358",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8667",
  "user-context": "/user-context/static-1.4751",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.762",
  "hubspotter-http": "/hubspotter-http/static-1.4350",
  "icons": "/icons/static-2.605",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.455",
  "quartz-auth": "/quartz-auth/static-1.200",
  "quartz-head": "/quartz-head/static-1.190",
  "quartz-test": "/quartz-test/static-1.200",
  "ui-fonts": "/ui-fonts/static-1.344",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9093",
  "data-token-picker": "/data-token-picker/static-1.15824",
  "FileManagerLib": "/FileManagerLib/static-1.38131",
  "property-translator": "/property-translator/static-1.5078",
  "atom": "/atom/static-1.4737",
  "feature-store-service-types": "/feature-store-service-types/static-1.4191",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4198",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "purchase-motions-components": "/purchase-motions-components/static-1.5275",
  "salesImages": "/salesImages/static-1.518",
  "self-service-api": "/self-service-api/static-1.9886",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4701",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.91",
  "ui-images": "/ui-images/static-2.1047",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3487",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.911",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2547",
  "foundations-theming-base": "/foundations-theming-base/static-1.3049",
  "stylex": "/stylex/static-1.25",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4139",
  "react-flip-move": "/react-flip-move/static-1.63",
  "bender-build-tools": "/bender-build-tools/static-1.2770",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3552",
  "superstore": "/superstore/static-1.4432",
  "feedback-loader": "/feedback-loader/static-1.28619",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7991",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8386",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27560",
  "sassPrefix": "/sassPrefix/static-1.149",
  "react-dnd-compat": "/react-dnd-compat/static-1.4288",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2124",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7822",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4312",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10866",
  "content-media-compositions": "/content-media-compositions/static-2.14873",
  "idb-keyval": "/idb-keyval/static-1.37",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3818",
  "magpie-lib": "/magpie-lib/static-1.5237",
  "magpie-types": "/magpie-types/static-1.4697",
  "media-bridge-lib": "/media-bridge-lib/static-1.18350",
  "video-data-lib": "/video-data-lib/static-1.33802",
  "commerce-products-lib": "/commerce-products-lib/static-1.8429",
  "crm-message-bus": "/crm-message-bus/static-1.41969",
  "growth-data-modal": "/growth-data-modal/static-1.4992",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4542",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4289",
  "calling-global-api": "/calling-global-api/static-1.63185",
  "calling-internal-common": "/calling-internal-common/static-1.30950",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64567",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56861",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3494",
  "crm-links": "/crm-links/static-1.5907",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12663",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7728",
  "external-options-client-types": "/external-options-client-types/static-1.3855",
  "file-manager-components": "/file-manager-components/static-1.22491",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6527",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.312",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3331",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3922",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.297",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3394",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47506",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3658",
  "property-value-citations": "/property-value-citations/static-1.983",
  "pulse": "/pulse/static-1.145",
  "smart-property-lib": "/smart-property-lib/static-1.5379",
  "tiered-pricing": "/tiered-pricing/static-1.613",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10660",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2716",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1151",
  "navigation-components": "/navigation-components/static-1.16880",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.141",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7183",
  "ui-universal-auth": "/ui-universal-auth/static-1.8498",
  "batch-promise": "/batch-promise/static-1.1191",
  "navigation-messaging": "/navigation-messaging/static-1.6207",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16583",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9127",
  "audio-components": "/audio-components/static-1.5419",
  "FileManagerCore": "/FileManagerCore/static-1.37990",
  "FileManagerImages": "/FileManagerImages/static-1.35642",
  "video-components": "/video-components/static-1.12147",
  "nav-client-types": "/nav-client-types/static-1.1995",
  "purchase-motions-api": "/purchase-motions-api/static-1.5278",
  "signup-constants": "/signup-constants/static-1.18103",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "trials-service-types": "/trials-service-types/static-1.3599",
  "chatspot-core": "/chatspot-core/static-1.19790",
  "ContentUtils": "/ContentUtils/static-1.67180",
  "copilot-toolkit": "/copilot-toolkit/static-1.10183",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6250",
  "hls.js": "/hls.js/static-1.32",
  "reactive-lib": "/reactive-lib/static-1.390",
  "simple-logging-lib": "/simple-logging-lib/static-1.2714",
  "customer-data-tracking": "/customer-data-tracking/static-1.6525",
  "products-iframe-lib": "/products-iframe-lib/static-1.6988",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9511",
  "calling-error-reporting": "/calling-error-reporting/static-1.30956",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10680",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6202",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34373",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6915",
  "usage-tracker-container": "/usage-tracker-container/static-1.6989",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8118",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3838",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3720",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6432",
  "persist-promise": "/persist-promise/static-1.3348",
  "directed-graph": "/directed-graph/static-1.598",
  "event-emitter": "/event-emitter/static-1.589",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5122",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9212",
  "fsm": "/fsm/static-1.3393",
  "policy-lib": "/policy-lib/static-1.6466",
  "react-tinymce": "/react-tinymce/static-1.54242",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9275",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53368",
  "tinymce-plugins": "/tinymce-plugins/static-1.56482",
  "tinymce-themes": "/tinymce-themes/static-1.55338",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4189",
  "video-embed": "/video-embed/static-1.34636",
  "content-icons-ui": "/content-icons-ui/static-1.2102",
  "social-insights-client-types": "/social-insights-client-types/static-1.21028",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2880",
  "chatspot-client-types": "/chatspot-client-types/static-1.10305",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4466",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.3955",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34598",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3332",
  "highcharts": "/highcharts/static-8.97",
  "trellis-story-utils": "/trellis-story-utils/static-1.4188",
  "storybook-react": "/storybook-react/static-1.26",
  "hub-http-contrib": "/hub-http-contrib/static-1.2711",
  "interframe": "/interframe/static-3.4453",
  "tinymce-data": "/tinymce-data/static-1.39453",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4878",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11794",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10769",
  "react-codemirror": "/react-codemirror/static-1.10266",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13317",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8774",
  "outpost": "/outpost/static-1.3880",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67255",
  "layout-data-lib": "/layout-data-lib/static-1.9094",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.14600",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11601",
  "ExportDialog": "/ExportDialog/static-6.10051",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33052",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14599",
  "ReduxMessenger": "/ReduxMessenger/static-2.10038",
  "simple-menus-lib": "/simple-menus-lib/static-1.16116"
}
};
